import { Controller, Control } from 'react-hook-form';
import { LocalizationProvider, TimePicker as TimePickerComponent } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface Props {
  name: string;
  control: Control<any>;
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  sx?: any;
}

export default function TimePicker({ name, control, label, disabled, fullWidth, sx }: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => {
          const parsedTime =
            field.value !== 'undefined' && Boolean(field.value)
              ? dayjs(field.value, 'H:mm') // Use 24h format for parsing internally if needed, but dayjs handles it
              : null;
          return (
            <TimePickerComponent
              {...field}
              label={label}
              disabled={disabled}
              value={parsedTime}
              onChange={(newValue) => {
                if (!newValue) {
                  field.onChange(null);
                  return;
                }
                if (newValue.isValid()) {
                  field.onChange(newValue.format('HH:mm'));
                }
              }}
              ampm={true}
              slotProps={{
                textField: {
                  fullWidth: fullWidth,
                  sx: {
                    width: fullWidth ? '100%' : 150,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: fullWidth ? '8px' : undefined,
                      backgroundColor: '#fff'
                    },
                    ...sx
                  },
                  error: !!fieldState.error,
                  helperText: fieldState.error?.message
                }
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
}
